const translations = {
    mapError: 'Failed to create map for flight group.'
};

export default translations;
